import SVGANIMATION from '../../../../DOM/svg/SVGOBJECT/SVGANIMATION.js';
import { SVGANIMATIONELEMENT } from '../../../../../enums/SVGANIMATIONELEMENT.js';
import { makeAttrStruct } from '../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../enums/ModelData.js';
import { makeStruct } from '../../../../../enums/MODELS.js';
;
// Model Structure
export const svgAnimationAttr = makeAttrStruct([
    ['path'],
    ['begin'],
    ['dur'],
]);
export const svgAnimateMotionData = makeDataStruct([]);
export const svgAnimateMotionModel = makeStruct([
    ['attributes', svgAnimationAttr],
    ['data', svgAnimateMotionData]
]);
// Simplified Model
export function svgAnimateMotion(path, begin, dur) {
    return {
        attributes: svgAnimationAttr(path, begin, dur),
        data: svgAnimateMotionData()
    };
}
/** Creates an animation object for an SVG Shape */
export default class SVGANIMATEMOTION extends SVGANIMATION {
    constructor(node, model) {
        super(node, SVGANIMATIONELEMENT.ANIMATEMOTION, model);
    }
}
